"use client"

import { FavoriteBox } from "@/widgets/FavoriteBox";

const FavoritePageView = () => {
    
    return (
        <>
            <h1 className="hidden">좋아요 한 문화정보 페이지</h1>
            <FavoriteBox/>
        </>
    )
}

export default FavoritePageView